// Tính năng suất theo nhóm, tách nguyên từ loadData của src/pages/BaoCaoNangSuat.js để báo cáo năng suất
// và bảng lương dùng chung một phép tính.
//
// Kết quả phải giống hệt báo cáo cũ. Mỗi dòng có thêm vài trường bắt đầu bằng "_" cho bảng lương
// (tổ–công đoạn, SỐ HĐ người phụ trách, tiền hiệu chỉnh); báo cáo không hiển thị và không xuất các trường này.

const getSign = (nghiepVu) => {
  if (nghiepVu === 'Nhập') return 1;
  if (nghiepVu === 'Chuyển') return -1;
  return 0;
};

const formatNumber = (val) => {
  const n = Number(val || 0);
  if (Number.isNaN(n)) return '0';
  return n.toLocaleString('vi-VN');
};

const formatDate = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString('vi-VN');
};

const getLastDayOfMonth = (year, month) => new Date(year, month, 0);

const getMonthKey = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// Tách số DAY từ TÊN CÔNG ĐOẠN (vd: "Hàng khô - 18" -> 18)
const extractDayFromCongDoan = (tenCongDoan) => {
  if (!tenCongDoan) return null;
  const match = tenCongDoan.match(/-\s*(\d+)$/);
  return match ? Number(match[1]) : null;
};

// So theo ngày (bỏ giờ) với khoảng lọc; khoảng để trống là không giới hạn.
const isWithinDateRange = (value, fromDate, toDate) => {
  const d = new Date(value);
  const dateOnly = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  if (fromDate) {
    const fromDateObj = new Date(fromDate);
    const fromDateOnly = new Date(fromDateObj.getFullYear(), fromDateObj.getMonth(), fromDateObj.getDate());
    if (dateOnly < fromDateOnly) return false;
  }
  if (toDate) {
    const toDateObj = new Date(toDate);
    const toDateOnly = new Date(toDateObj.getFullYear(), toDateObj.getMonth(), toDateObj.getDate());
    if (dateOnly > toDateOnly) return false;
  }
  return true;
};

// Khóa gộp dòng và ngày hiển thị: tính theo tháng thì gộp cả tháng và hiện ngày cuối tháng.
const periodKeyOf = (date, ppTinh, to, tenCongDoan) => {
  if (ppTinh === 'Tháng') return [getMonthKey(date), to, tenCongDoan].join('|');
  return [date.toISOString().split('T')[0], to, tenCongDoan].join('|');
};

const displayDateOf = (date, ppTinh) => {
  if (ppTinh === 'Tháng') {
    const [year, month] = getMonthKey(date).split('-').map(Number);
    return getLastDayOfMonth(year, month).toISOString();
  }
  return date.toISOString();
};

// Tìm công đoạn hợp lệ tại ngày và tính đơn giá (đã cộng hiệu chỉnh)
export const findValidCongDoanWithPrice = (toPbnsList, recordDate, congDoanDonGias, hieuChinhList) => {
  const targetDate = new Date(recordDate);
  const result = [];

  toPbnsList.forEach(pb => {
    // Hiệu lực phân bổ nhân sự (HIỆU LỰC TỪ / HIỆU LỰC ĐẾN của TO_PBNS)
    const pbTu = pb['HIỆU LỰC TỪ'] ? new Date(pb['HIỆU LỰC TỪ']) : null;
    const pbDen = pb['HIỆU LỰC ĐẾN'] ? new Date(pb['HIỆU LỰC ĐẾN']) : null;
    const isPbActive = (!pbTu || targetDate >= pbTu) && (!pbDen || targetDate <= pbDen);
    if (!isPbActive) return;

    const maCongDoan = pb['MÃ CÔNG ĐOẠN'];
    const idToCongDoan = pb['ID TỔ CÔNG ĐOẠN'];

    // 1. Đơn giá hiệu lực trong CONGDOAN_DONGIA
    const matchingDonGia = congDoanDonGias.filter(cd => cd['MÃ CÔNG ĐOẠN'] === maCongDoan);
    const validDonGia = matchingDonGia.find(cd => {
      const tu = cd['HIỆU LỰC TỪ'] ? new Date(cd['HIỆU LỰC TỪ']) : null;
      const den = cd['HIỆU LỰC ĐẾN'] ? new Date(cd['HIỆU LỰC ĐẾN']) : null;
      return (!tu || targetDate >= tu) && (!den || targetDate <= den);
    });

    if (validDonGia) {
      let donGia = parseFloat(validDonGia['ĐƠN GIÁ NĂNG SUẤT'] || 0);
      let tienHieuChinh = 0;

      // 2. Hiệu chỉnh trong HIEU_CHINH_TIEN_NANG_SUAT
      const matchingHC = hieuChinhList.filter(hc => hc['ID TỔ CÔNG ĐOẠN'] === idToCongDoan);
      const validHC = matchingHC.find(hc => {
        const tu = hc['HIỆU LỰC TỪ'] ? new Date(hc['HIỆU LỰC TỪ']) : null;
        const den = hc['HIỆU LỰC ĐẾN'] ? new Date(hc['HIỆU LỰC ĐẾN']) : null;
        return (!tu || targetDate >= tu) && (!den || targetDate <= den);
      });

      if (validHC) {
        tienHieuChinh = parseFloat(validHC['TIỀN HIỆU CHỈNH'] || 0);
        donGia += tienHieuChinh;
      }

      result.push({
        ...pb,
        'ĐƠN GIÁ NĂNG SUẤT': donGia,
        _TIEN_HIEU_CHINH: tienHieuChinh,
      });
    }
  });

  return result;
};

// Công đoạn đang hiệu lực cho 1 record có TỔ
const findCongDoanListForRecord = (rec, toPbns, congDoanDonGias, hieuChinhList) => {
  const date = new Date(rec['NGÀY'] || rec['NGAY_NHAP_XUAT']);
  const teamFiltered = toPbns.filter(cd => cd['TỔ'] === rec['TỔ'] || cd['TỔ'] === rec['DOI_HANG_KHO']);
  return findValidCongDoanWithPrice(teamFiltered, date, congDoanDonGias, hieuChinhList);
};

// Trường cho bảng lương. Khóa gộp dòng là ngày + tổ + tên công đoạn, không có người phụ trách: nếu hai
// phân bổ khác nhau cùng rơi vào một khóa thì dòng chỉ mang người của phân bổ đầu, ghi lại để cảnh báo.
const payrollFields = (congDoan) => ({
  _ID_TO_CONG_DOAN: congDoan['ID TỔ CÔNG ĐOẠN'] || '',
  _MA_CONG_DOAN: congDoan['MÃ CÔNG ĐOẠN'] || '',
  _SO_HD: String(congDoan['SỐ HĐ PHỤ TRÁCH'] || '').trim(),
  _TIEN_HIEU_CHINH: congDoan._TIEN_HIEU_CHINH || 0,
  _MERGED_IDS: [],
});

const trackMergedAllocation = (row, congDoan) => {
  const id = congDoan['ID TỔ CÔNG ĐOẠN'] || '';
  if (id !== row._ID_TO_CONG_DOAN && !row._MERGED_IDS.includes(id)) row._MERGED_IDS.push(id);
};

/**
 * Tính năng suất cho mọi nhóm trong TO_PBNS.
 * input: { nhapCt, toPbnsRaw, nhapBaoBi, xuatNhapKhoCt, congDoanDonGias, hieuChinhList, fromDate, toDate }
 * Trả về { nhomList, dataByNhom }.
 */
export function calculateProductivityReport(input) {
  const {
    nhapCt, toPbnsRaw, nhapBaoBi, xuatNhapKhoCt, congDoanDonGias, hieuChinhList,
    fromDate: effectiveFromDate, toDate: effectiveToDate,
  } = input;

  const uniqueNhoms = [...new Set(toPbnsRaw.map(item => item['NHÓM']).filter(Boolean))];
  const dataByNhom = {};

  uniqueNhoms.forEach(nhom => {
    const toPbns = toPbnsRaw.filter((r) => r['NHÓM'] === nhom);
    let result = [];

    if (nhom === 'Bao bì anh' || nhom === 'Bao bì em') {
      // Nguồn NHAPBAOBI_CT, ghép theo TỔ của record
      const nhapCtFiltered = nhapCt.filter((rec) => isWithinDateRange(rec['NGÀY'], effectiveFromDate, effectiveToDate));
      const map = new Map();

      nhapCtFiltered.forEach((rec) => {
        const date = new Date(rec['NGÀY']);
        const congDoanList = findCongDoanListForRecord(rec, toPbns, congDoanDonGias, hieuChinhList);
        if (!congDoanList.length) return;

        const nghiepVu = rec['NGHIỆP VỤ'];
        const sign = getSign(nghiepVu);
        if (sign === 0) return;

        const kg = Number(rec['KHỐI LƯỢNG (KG)'] || 0);
        const soLong = Number(rec['SỐ LỒNG'] || 0);

        congDoanList.forEach((congDoan) => {
          const ppTinh = congDoan['PP TÍNH NĂNG SUẤT'];
          const key = periodKeyOf(date, ppTinh, rec['TỔ'], congDoan['TÊN CÔNG ĐOẠN']);

          if (!map.has(key)) {
            map.set(key, {
              NGÀY: displayDateOf(date, ppTinh),
              TỔ: rec['TỔ'],
              'CÔNG ĐOẠN': congDoan['TÊN CÔNG ĐOẠN'],
              'ĐƠN VỊ TÍNH': congDoan['ĐƠN VỊ TÍNH'],
              'PP TÍNH NĂNG SUẤT': ppTinh,
              'KHỐI LƯỢNG': 0,
              'SỐ LỒNG': 0,
              NHẬP_KG: 0,
              CHUYỂN_KG: 0,
              NHẬP_LONG: 0,
              CHUYỂN_LONG: 0,
              'NHÂN SỰ PHỤ TRÁCH': congDoan['NHÂN SỰ PHỤ TRÁCH'] || '',
              'ĐƠN GIÁ': congDoan['ĐƠN GIÁ NĂNG SUẤT'] || 0,
              'THÀNH TIỀN': 0,
              ...payrollFields(congDoan),
            });
          }

          const row = map.get(key);
          trackMergedAllocation(row, congDoan);

          if (nghiepVu === 'Nhập') {
            row.NHẬP_KG += kg;
            row.NHẬP_LONG += soLong;
          } else if (nghiepVu === 'Chuyển') {
            row.CHUYỂN_KG += kg;
            row.CHUYỂN_LONG += soLong;
          }

          row['KHỐI LƯỢNG'] += sign * kg;
          row['SỐ LỒNG'] += sign * soLong;
        });
      });

      result = Array.from(map.values()).map((row) => {
        const thanhTien = row['KHỐI LƯỢNG'] * row['ĐƠN GIÁ'];
        const historyParts = [];
        if (row.NHẬP_KG > 0) historyParts.push(`Nhập: ${formatNumber(row.NHẬP_KG)} Kg`);
        if (row.CHUYỂN_KG > 0) historyParts.push(`Chuyển: ${formatNumber(row.CHUYỂN_KG)} Kg`);
        const historyBody = historyParts.length > 0 ? historyParts.join(' ; ') : 'Không có phát sinh Nhập / Chuyển';
        return { ...row, 'THÀNH TIỀN': thanhTien, 'LỊCH SỬ': historyBody };
      });

    } else if (nhom === 'Hàng khô') {
      // Nguồn XUATNHAPKHO_CHITIET theo DOI_HANG_KHO và DAY, chỉ nghiệp vụ NHAP
      const xuatNhapKhoFiltered = xuatNhapKhoCt.filter((rec) => {
        if (!isWithinDateRange(rec['NGAY_NHAP_XUAT'], effectiveFromDate, effectiveToDate)) return false;
        return !!rec['DOI_HANG_KHO'] && rec['NGHIEP_VU'] === 'NHAP';
      });
      const map = new Map();

      xuatNhapKhoFiltered.forEach((rec) => {
        const date = new Date(rec['NGAY_NHAP_XUAT']);
        const recDay = Number(rec['DAY'] || 0);

        const teamFiltered = toPbns.filter((cd) => {
          if (cd['TỔ'] !== rec['DOI_HANG_KHO']) return false;
          const congDoanDay = extractDayFromCongDoan(cd['TÊN CÔNG ĐOẠN']);
          if (congDoanDay !== null && congDoanDay !== recDay) return false;
          return true;
        });

        const congDoanList = findValidCongDoanWithPrice(teamFiltered, date, congDoanDonGias, hieuChinhList);
        if (!congDoanList.length) return;

        const soKhoi = Number(rec['SO_KHOI'] || 0);

        congDoanList.forEach((congDoan) => {
          const ppTinh = congDoan['PP TÍNH NĂNG SUẤT'];
          const key = periodKeyOf(date, ppTinh, rec['DOI_HANG_KHO'], congDoan['TÊN CÔNG ĐOẠN']);

          if (!map.has(key)) {
            map.set(key, {
              NGÀY: displayDateOf(date, ppTinh),
              TỔ: rec['DOI_HANG_KHO'],
              'CÔNG ĐOẠN': congDoan['TÊN CÔNG ĐOẠN'],
              'ĐƠN VỊ TÍNH': congDoan['ĐƠN VỊ TÍNH'],
              'PP TÍNH NĂNG SUẤT': ppTinh,
              'KHỐI LƯỢNG': 0,
              'NHÂN SỰ PHỤ TRÁCH': congDoan['NHÂN SỰ PHỤ TRÁCH'] || '',
              'ĐƠN GIÁ': parseFloat(congDoan['ĐƠN GIÁ NĂNG SUẤT']) || 0,
              'THÀNH TIỀN': 0,
              DETAILS: [],
              ...payrollFields(congDoan),
            });
          }

          const row = map.get(key);
          trackMergedAllocation(row, congDoan);
          row['KHỐI LƯỢNG'] += soKhoi;

          if (soKhoi > 0) {
            row.DETAILS.push(`${rec['SOPHIEU'] || 'N/A'} - NHAP - DAY ${recDay}: ${formatNumber(soKhoi)} khối`);
          }
        });
      });

      result = Array.from(map.values()).map((row) => {
        const thanhTien = row['KHỐI LƯỢNG'] * row['ĐƠN GIÁ'];
        const historyBody = row.DETAILS.length > 0 ? row.DETAILS.join(' ; ') : 'Không có dữ liệu';
        return { ...row, 'THÀNH TIỀN': thanhTien, 'LỊCH SỬ': historyBody };
      });

    } else if (nhom === 'Cân' || nhom === 'Tẩm' || nhom === 'Hàng tươi' || nhom === 'Bãi') {
      // Nguồn THỰC NHẬN BB (KG) trong NHAPBAOBI, áp cho mọi tổ của nhóm
      const uniqueTos = [...new Set(toPbns.map(cd => cd['TỔ']))];
      const nhapBaoBiFiltered = nhapBaoBi.filter((rec) => isWithinDateRange(rec['NGÀY THÁNG'], effectiveFromDate, effectiveToDate));
      const dataByPeriod = new Map();

      nhapBaoBiFiltered.forEach((rec) => {
        const date = new Date(rec['NGÀY THÁNG']);
        const thucNhanBB = Number(rec['THỰC NHẬN BB (KG)'] || 0);

        uniqueTos.forEach((to) => {
          const teamFiltered = toPbns.filter(cd => cd['TỔ'] === to);
          const validCongDoan = findValidCongDoanWithPrice(teamFiltered, date, congDoanDonGias, hieuChinhList);

          validCongDoan.forEach((congDoan) => {
            const ppTinh = congDoan['PP TÍNH NĂNG SUẤT'];
            const periodKey = periodKeyOf(date, ppTinh, to, congDoan['TÊN CÔNG ĐOẠN']);

            if (!dataByPeriod.has(periodKey)) {
              dataByPeriod.set(periodKey, {
                NGÀY: displayDateOf(date, ppTinh),
                TỔ: to,
                'CÔNG ĐOẠN': congDoan['TÊN CÔNG ĐOẠN'],
                'ĐƠN VỊ TÍNH': congDoan['ĐƠN VỊ TÍNH'],
                'PP TÍNH NĂNG SUẤT': ppTinh,
                'KHỐI LƯỢNG': 0,
                'NHÂN SỰ PHỤ TRÁCH': congDoan['NHÂN SỰ PHỤ TRÁCH'] || '',
                'ĐƠN GIÁ': congDoan['ĐƠN GIÁ NĂNG SUẤT'] || 0,
                'THÀNH TIỀN': 0,
                DETAILS: [],
                ...payrollFields(congDoan),
              });
            }

            const row = dataByPeriod.get(periodKey);
            trackMergedAllocation(row, congDoan);
            row['KHỐI LƯỢNG'] += thucNhanBB;
            if (thucNhanBB > 0) {
              row.DETAILS.push(`${rec['SỐ XE'] || 'N/A'}: ${formatNumber(thucNhanBB)} Kg`);
            }
          });
        });
      });

      result = Array.from(dataByPeriod.values()).map((row) => {
        const thanhTien = row['KHỐI LƯỢNG'] * row['ĐƠN GIÁ'];
        const historyBody = row.DETAILS.length > 0 ? row.DETAILS.join(' ; ') : 'Không có dữ liệu';
        return { ...row, 'THÀNH TIỀN': thanhTien, 'LỊCH SỬ': historyBody };
      });

    } else if (nhom === 'Thợ mũi A' || nhom === 'Thợ mũi E' || nhom === 'Bo lồng') {
      // Thợ mũi A: tổng KHỐI LƯỢNG (KG) của "Bao bì anh"; Thợ mũi E: của "Bao bì em";
      // Bo lồng: tổng SỐ LỒNG của "Bao bì em". Áp cho mọi tổ của nhóm.
      const tenHang = nhom === 'Thợ mũi A' ? 'Bao bì anh' : 'Bao bì em';
      const quantityColumn = nhom === 'Bo lồng' ? 'SỐ LỒNG' : 'KHỐI LƯỢNG (KG)';
      const unitLabel = nhom === 'Bo lồng' ? 'Lồng' : 'Kg';

      const nhapCtFiltered = nhapCt.filter((rec) => {
        if (!isWithinDateRange(rec['NGÀY'], effectiveFromDate, effectiveToDate)) return false;
        return rec['TÊN HÀNG'] === tenHang;
      });
      const dataByPeriod = new Map();

      nhapCtFiltered.forEach((rec) => {
        const date = new Date(rec['NGÀY']);
        const nghiepVu = rec['NGHIỆP VỤ'];
        const sign = getSign(nghiepVu);
        if (sign === 0) return;

        const kg = Number(rec[quantityColumn] || 0);
        const uniqueTos = [...new Set(toPbns.map(cd => cd['TỔ']))];

        uniqueTos.forEach((to) => {
          const teamFiltered = toPbns.filter(cd => cd['TỔ'] === to);
          const validCongDoan = findValidCongDoanWithPrice(teamFiltered, date, congDoanDonGias, hieuChinhList);

          validCongDoan.forEach((congDoan) => {
            const ppTinh = congDoan['PP TÍNH NĂNG SUẤT'];
            const periodKey = periodKeyOf(date, ppTinh, to, congDoan['TÊN CÔNG ĐOẠN']);

            if (!dataByPeriod.has(periodKey)) {
              dataByPeriod.set(periodKey, {
                NGÀY: displayDateOf(date, ppTinh),
                TỔ: to,
                'CÔNG ĐOẠN': congDoan['TÊN CÔNG ĐOẠN'],
                'ĐƠN VỊ TÍNH': congDoan['ĐƠN VỊ TÍNH'],
                'PP TÍNH NĂNG SUẤT': ppTinh,
                'KHỐI LƯỢNG': 0,
                NHẬP_KG: 0,
                CHUYỂN_KG: 0,
                'NHÂN SỰ PHỤ TRÁCH': congDoan['NHÂN SỰ PHỤ TRÁCH'] || '',
                'ĐƠN GIÁ': congDoan['ĐƠN GIÁ NĂNG SUẤT'] || 0,
                'THÀNH TIỀN': 0,
                ...payrollFields(congDoan),
              });
            }

            const row = dataByPeriod.get(periodKey);
            trackMergedAllocation(row, congDoan);

            if (nghiepVu === 'Nhập') {
              row.NHẬP_KG += kg;
            } else if (nghiepVu === 'Chuyển') {
              row.CHUYỂN_KG += kg;
            }

            row['KHỐI LƯỢNG'] += sign * kg;
          });
        });
      });

      result = Array.from(dataByPeriod.values()).map((row) => {
        const thanhTien = row['KHỐI LƯỢNG'] * row['ĐƠN GIÁ'];
        const historyParts = [];
        if (row.NHẬP_KG > 0) historyParts.push(`Nhập: ${formatNumber(row.NHẬP_KG)} ${unitLabel}`);
        if (row.CHUYỂN_KG > 0) historyParts.push(`Chuyển: ${formatNumber(row.CHUYỂN_KG)} ${unitLabel}`);
        const historyBody = historyParts.length > 0 ? historyParts.join(' ; ') : 'Không có phát sinh';
        return { ...row, 'THÀNH TIỀN': thanhTien, 'LỊCH SỬ': historyBody };
      });

    } else if (nhom === 'Pallet') {
      // Nguồn NHAPBAOBI_CT có TÊN HÀNG = "Pallet"; NGHIỆP VỤ của record chính là TÊN CÔNG ĐOẠN
      const nhapCtFiltered = nhapCt.filter((rec) => {
        if (!isWithinDateRange(rec['NGÀY'], effectiveFromDate, effectiveToDate)) return false;
        return rec['TÊN HÀNG'] === 'Pallet';
      });
      const map = new Map();

      nhapCtFiltered.forEach((rec) => {
        const date = new Date(rec['NGÀY']);
        const nghiepVu = rec['NGHIỆP VỤ'];

        const teamFiltered = toPbns.filter((cd) => {
          if (cd['TÊN CÔNG ĐOẠN'] !== nghiepVu) return false;
          if (cd['TỔ'] !== rec['TỔ']) return false;
          return true;
        });

        const congDoanList = findValidCongDoanWithPrice(teamFiltered, date, congDoanDonGias, hieuChinhList);
        if (!congDoanList.length) return;

        const kg = Number(rec['KHỐI LƯỢNG (KG)'] || 0);

        congDoanList.forEach((congDoan) => {
          const ppTinh = congDoan['PP TÍNH NĂNG SUẤT'];
          const key = periodKeyOf(date, ppTinh, rec['TỔ'], congDoan['TÊN CÔNG ĐOẠN']);

          if (!map.has(key)) {
            map.set(key, {
              NGÀY: displayDateOf(date, ppTinh),
              TỔ: rec['TỔ'],
              'CÔNG ĐOẠN': congDoan['TÊN CÔNG ĐOẠN'],
              'ĐƠN VỊ TÍNH': congDoan['ĐƠN VỊ TÍNH'],
              'PP TÍNH NĂNG SUẤT': ppTinh,
              'KHỐI LƯỢNG': 0,
              'NHÂN SỰ PHỤ TRÁCH': congDoan['NHÂN SỰ PHỤ TRÁCH'] || '',
              'ĐƠN GIÁ': congDoan['ĐƠN GIÁ NĂNG SUẤT'] || 0,
              'THÀNH TIỀN': 0,
              DETAILS: [],
              ...payrollFields(congDoan),
            });
          }

          const row = map.get(key);
          trackMergedAllocation(row, congDoan);
          row['KHỐI LƯỢNG'] += kg;

          if (kg > 0) {
            row.DETAILS.push(`${formatDate(rec['NGÀY'])} - ${nghiepVu}: ${formatNumber(kg)} cái`);
          }
        });
      });

      result = Array.from(map.values()).map((row) => {
        const thanhTien = row['KHỐI LƯỢNG'] * row['ĐƠN GIÁ'];
        const historyBody = row.DETAILS.length > 0 ? row.DETAILS.join(' ; ') : 'Không có dữ liệu';
        return { ...row, 'THÀNH TIỀN': thanhTien, 'LỊCH SỬ': historyBody };
      });

    } else if (nhom === 'Hốt mùn') {
      // Nguồn NHAPBAOBI_CT như Bao bì anh/em, không lọc TÊN HÀNG, ghép theo TỔ
      const nhapCtFiltered = nhapCt.filter((rec) => isWithinDateRange(rec['NGÀY'], effectiveFromDate, effectiveToDate));
      const map = new Map();

      nhapCtFiltered.forEach((rec) => {
        const date = new Date(rec['NGÀY']);
        const congDoanList = findCongDoanListForRecord(rec, toPbns, congDoanDonGias, hieuChinhList);
        if (!congDoanList.length) return;

        const nghiepVu = rec['NGHIỆP VỤ'];
        const sign = getSign(nghiepVu);
        if (sign === 0) return;

        const kg = Number(rec['KHỐI LƯỢNG (KG)'] || 0);
        const soLong = Number(rec['SỐ LỒNG'] || 0);

        congDoanList.forEach((congDoan) => {
          const ppTinh = congDoan['PP TÍNH NĂNG SUẤT'];
          const key = periodKeyOf(date, ppTinh, rec['TỔ'], congDoan['TÊN CÔNG ĐOẠN']);

          if (!map.has(key)) {
            map.set(key, {
              NGÀY: displayDateOf(date, ppTinh),
              TỔ: rec['TỔ'],
              'CÔNG ĐOẠN': congDoan['TÊN CÔNG ĐOẠN'],
              'ĐƠN VỊ TÍNH': congDoan['ĐƠN VỊ TÍNH'],
              'PP TÍNH NĂNG SUẤT': ppTinh,
              'KHỐI LƯỢNG': 0,
              'SỐ LỒNG': 0,
              NHẬP_KG: 0,
              CHUYỂN_KG: 0,
              'NHÂN SỰ PHỤ TRÁCH': congDoan['NHÂN SỰ PHỤ TRÁCH'] || '',
              'ĐƠN GIÁ': congDoan['ĐƠN GIÁ NĂNG SUẤT'] || 0,
              'THÀNH TIỀN': 0,
              ...payrollFields(congDoan),
            });
          }

          const row = map.get(key);
          trackMergedAllocation(row, congDoan);
          if (nghiepVu === 'Nhập') { row.NHẬP_KG += kg; }
          else if (nghiepVu === 'Chuyển') { row.CHUYỂN_KG += kg; }
          row['KHỐI LƯỢNG'] += sign * kg;
          row['SỐ LỒNG'] += sign * soLong;
        });
      });

      result = Array.from(map.values()).map((row) => {
        const thanhTien = row['KHỐI LƯỢNG'] * row['ĐƠN GIÁ'];
        const historyParts = [];
        if (row.NHẬP_KG > 0) historyParts.push(`Nhập: ${formatNumber(row.NHẬP_KG)} Kg`);
        if (row.CHUYỂN_KG > 0) historyParts.push(`Chuyển: ${formatNumber(row.CHUYỂN_KG)} Kg`);
        return {
          ...row,
          'THÀNH TIỀN': thanhTien,
          'LỊCH SỬ': historyParts.length > 0 ? historyParts.join(' ; ') : 'Không có phát sinh Nhập / Chuyển',
        };
      });
    }

    result.sort((a, b) => {
      const da = new Date(a.NGÀY);
      const db = new Date(b.NGÀY);
      if (da.getTime() !== db.getTime()) return da - db;
      if (a.TỔ !== b.TỔ) return a.TỔ.localeCompare(b.TỔ);
      return a['CÔNG ĐOẠN'].localeCompare(b['CÔNG ĐOẠN']);
    });

    dataByNhom[nhom] = result;
  });

  return { nhomList: uniqueNhoms, dataByNhom };
}

/**
 * Đổi kết quả báo cáo thành dòng năng suất cho bảng lương (dạng ProductivityRow của V2), để đưa vào
 * calculateProductivityLines. Người nhận là SỐ HĐ PHỤ TRÁCH; dòng chưa gắn SỐ HĐ có employeeId null và
 * sẽ rơi vào danh sách không xác định người nhận.
 */
export function toPayrollProductivityRows(dataByNhom) {
  return Object.entries(dataByNhom).flatMap(([nhom, rows]) => rows.map((row, index) => ({
    id: `${nhom}|${row.NGÀY}|${row.TỔ}|${row['CÔNG ĐOẠN']}|${index}`,
    employeeId: row._SO_HD || null,
    allocationId: row._ID_TO_CONG_DOAN || null,
    maCongDoan: row._MA_CONG_DOAN,
    nhom,
    ngay: row.NGÀY,
    to: row.TỔ,
    congDoan: row['CÔNG ĐOẠN'],
    donViTinh: row['ĐƠN VỊ TÍNH'] || '',
    ppTinhNangSuat: row['PP TÍNH NĂNG SUẤT'] || '',
    khoiLuong: Number(row['KHỐI LƯỢNG']) || 0,
    soLong: Number(row['SỐ LỒNG']) || 0,
    nhanSuPhuTrach: row['NHÂN SỰ PHỤ TRÁCH'] || '',
    donGia: Number(row['ĐƠN GIÁ']) || 0,
    tienHieuChinh: Number(row._TIEN_HIEU_CHINH) || 0,
    thanhTien: Number(row['THÀNH TIỀN']) || 0,
    mergedAllocationIds: row._MERGED_IDS,
    source: nhom,
  })));
}
